export default __webpack_public_path__ + "static/media/barkhausen.8da20098.md";